import React, { useEffect, useRef } from 'react';
import WikiTiptapEditor from '../editor/WikiTiptapEditor';
import { normalizeTiptapDocument } from '../../services/wikiContentSerializer';

function WikiContentViewer({ article, tocEntries = [] }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !tocEntries.length) {
      return;
    }

    const headings = containerRef.current.querySelectorAll('.ProseMirror h1, .ProseMirror h2, .ProseMirror h3');
    headings.forEach((heading, index) => {
      const entry = tocEntries[index];
      if (entry?.id) {
        heading.id = entry.id;
      }
    });
  }, [article?.id, tocEntries]);

  return (
    <div className="wiki-article-body wiki-tiptap-viewer" ref={containerRef}>
      <WikiTiptapEditor
        readOnly
        value={normalizeTiptapDocument(article?.contentJson || article?.plainText || article?.content || '')}
      />
    </div>
  );
}

export default WikiContentViewer;
